(() => {
  if (window.ctCompactLiveaboardReady) return;
  window.ctCompactLiveaboardReady = true;
  function initCabinRows() {
    const section = document.getElementById('ct-liveaboard-departures');
    if (!section || section.dataset.compactRowsReady) return;
    section.dataset.compactRowsReady = 'true';
    section.querySelectorAll('[data-ct-cabin-from]').forEach((row) => {
      const unit = window.CTLiveaboardPricing?.pricingUnit(row.dataset);
      row.querySelector('[data-ct-cabin-from-unit]').textContent = ({per_person:'per person',per_cabin:'per cabin / sailing',per_charter:'per vessel / sailing'})[unit] || 'See pricing options';
      try { row.querySelector('[data-ct-cabin-from-amount]').textContent = new Intl.NumberFormat('en-GB',{style:'currency',currency:row.dataset.currency,maximumFractionDigits:2}).format(Number(row.dataset.rate)); } catch (_) { /* Keep the server-rendered amount. */ }
    });
    const updateRows = () => section.querySelectorAll('.ct-cabin-row').forEach((card) => {
      let units = 0, guests = 0;
      card.querySelectorAll('.ct-cabin-offer-source [data-ct-agent-cabin]').forEach((control) => {
        units += Number(control.querySelector('[data-ct-cabin-quantity]')?.textContent) || 0;
        guests += Number(control.querySelector('[data-ct-guest-quantity]')?.textContent) || 0;
      });
      const status = card.querySelector('[data-ct-card-selection]');
      if (status) { status.hidden = units < 1; status.textContent = `${units} selection${units===1?'':'s'} · ${guests} guest${guests===1?'':'s'}`; }
      const button = card.querySelector('[data-ct-choose-cabin]');
      if (button) button.textContent = units ? 'Edit selection' : 'Choose cabin';
    });
    const schedule = () => Promise.resolve().then(updateRows);
    section.addEventListener('click', schedule, true);
    section.addEventListener('close', schedule, true);
    updateRows();
  }
  if (!customElements.get('ct-route-guide')) {
    customElements.define('ct-route-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) { document.addEventListener('click',this.onAnchorClick); return; }
        const details = this.querySelector('details');
        const trigger = details?.querySelector('summary');
        const body = details?.querySelector('.ct-route-guide__body');
        const dialog = document.createElement('dialog');
        if (!trigger || !body || typeof dialog.showModal !== 'function') return;
        this.ready = true; this.dialog = dialog; this.body = body;
        dialog.className = 'ct-route-guide-dialog'; dialog.id=this.dataset.guideId;
        const titleId = `${this.dataset.guideId}-title`;
        dialog.setAttribute('aria-labelledby',titleId);
        const header = document.createElement('header');
        header.className = 'ct-route-guide-dialog__header';
        header.innerHTML = '<div><p>Route & diving guide</p><h2></h2></div><button type="button" class="ct-route-guide-dialog__close" aria-label="Close route guide">×</button><nav class="ct-route-guide-dialog__nav" aria-label="Route guide sections"></nav>';
        if(this.dataset.snorkeling==='true')header.querySelector('p').textContent='Route & snorkeling guide';
        const title = header.querySelector('h2'); title.id = titleId; title.textContent = this.dataset.guideTitle;
        for (const [id,label] of [['ct-liveaboard-overview','Overview'],['ct-liveaboard-itinerary','Itinerary'],['ct-liveaboard-diving',this.dataset.snorkeling==='true'?'Snorkeling & practical info':'Diving & practical info']]) {
          if (body.querySelector(`#${id}`)) { const link=document.createElement('a');link.href=`#${id}`;link.textContent=label;header.querySelector('nav').append(link); }
        }
        const footer = document.createElement('footer');
        footer.className = 'ct-route-guide-dialog__footer';
        footer.innerHTML = '<span>Explore the programme, then choose your sailing.</span><button type="button" class="ct-route-guide-dialog__departures">View departures & cabins</button>';
        dialog.append(header,body,footer);this.append(dialog);
        trigger.setAttribute('aria-haspopup','dialog');trigger.setAttribute('aria-controls',dialog.id);trigger.setAttribute('aria-expanded','false');
        const open = (opener,target) => {
          if (!dialog.open) { this.opener=opener;this.previousOverflow=document.body.style.overflow;dialog.showModal();trigger.setAttribute('aria-expanded','true');document.body.style.overflow='hidden'; }
          if (target) target.scrollIntoView({block:'start'});else dialog.scrollTop=0;
        };
        trigger.addEventListener('click',(event)=>{event.preventDefault();open(trigger);});
        header.querySelector('button').addEventListener('click',()=>dialog.close());
        dialog.addEventListener('click',(event)=>{if(event.target===dialog)dialog.close();});
        dialog.addEventListener('close',()=>{trigger.setAttribute('aria-expanded','false');document.body.style.overflow=this.previousOverflow||'';if(this.opener?.isConnected)this.opener.focus();});
        footer.querySelector('button').addEventListener('click',()=>{dialog.close();document.getElementById('ct-liveaboard-departures')?.scrollIntoView({block:'start'});});
        this.onAnchorClick = (event) => {
          const link = event.target.closest('a[href^="#"]');
          if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          let id;try{id=decodeURIComponent(link.getAttribute('href').slice(1));}catch(_){return;}
          const target=document.getElementById(id);
          if (!target || !body.contains(target)) return;
          event.preventDefault();open(dialog.open?this.opener:link,target);
        };
        document.addEventListener('click',this.onAnchorClick);
        let initialTarget;try{initialTarget=document.getElementById(decodeURIComponent(window.location.hash.slice(1)));}catch(_){}
        if(initialTarget&&body.contains(initialTarget))open(trigger,initialTarget);
      }
      disconnectedCallback() {
        document.removeEventListener('click',this.onAnchorClick);
        if(this.dialog?.open){this.dialog.close();document.body.style.overflow=this.previousOverflow||'';}
      }
    });
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',initCabinRows);else initCabinRows();
  document.addEventListener('shopify:section:load',initCabinRows);
})();
